"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCheckingAccounts = exports.CHECKING_ACCOUNTS_SUCCESS = exports.CHECKING_ACCOUNTS_QUERY = exports.CHECKING_ACCOUNTS_LOAD = exports.CHECKING_ACCOUNTS_FAILURE = exports.CHECKING_ACCOUNTS = void 0;

var _utils = require("@navinc/utils");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var CHECKING_ACCOUNT_FIELDS = "\nfragment checkingAccountFields on CheckingAccount {\n  id\n  name\n  imageUrl\n  url\n  description\n  tagline\n  monthlyCost\n  minimumBalance\n  monthlyFreeTransactions\n  perk\n  offerOwner\n  rtid\n  tags {\n    name\n    value\n  }\n}\n";
var CHECKING_ACCOUNTS = "\ncheckingAccounts(affiliateOwnerName: $affiliateOwnerName) {\n  ...checkingAccountFields\n}\n";
exports.CHECKING_ACCOUNTS = CHECKING_ACCOUNTS;
var CHECKING_ACCOUNTS_QUERY = "\nquery checkingAccounts($affiliateOwnerName: String) {\n  ".concat(CHECKING_ACCOUNTS, "\n}\n").concat(CHECKING_ACCOUNT_FIELDS, "\n");
exports.CHECKING_ACCOUNTS_QUERY = CHECKING_ACCOUNTS_QUERY;
var CHECKING_ACCOUNTS_LOAD = 'CHECKING_ACCOUNTS_LOAD';
exports.CHECKING_ACCOUNTS_LOAD = CHECKING_ACCOUNTS_LOAD;
var CHECKING_ACCOUNTS_FAILURE = 'CHECKING_ACCOUNTS_FAILURE';
exports.CHECKING_ACCOUNTS_FAILURE = CHECKING_ACCOUNTS_FAILURE;
var CHECKING_ACCOUNTS_SUCCESS = 'CHECKING_ACCOUNTS_SUCCESS';
exports.CHECKING_ACCOUNTS_SUCCESS = CHECKING_ACCOUNTS_SUCCESS;

var fetchCheckingAccounts = function fetchCheckingAccounts() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$affiliateOwnerNa = _ref.affiliateOwnerName,
      affiliateOwnerName = _ref$affiliateOwnerNa === void 0 ? fetchCheckingAccounts.getConfig().affiliateOwnerName : _ref$affiliateOwnerNa,
      _ref$apiUrl = _ref.apiUrl,
      apiUrl = _ref$apiUrl === void 0 ? fetchCheckingAccounts.getConfig().apiUrl : _ref$apiUrl,
      _ref$authToken = _ref.authToken,
      authToken = _ref$authToken === void 0 ? fetchCheckingAccounts.getConfig().authToken || _jsCookie["default"].get('token') : _ref$authToken,
      _ref$clientName = _ref.clientName,
      clientName = _ref$clientName === void 0 ? fetchCheckingAccounts.getConfig().clientName || 'ent-web' : _ref$clientName;

  return {
    loadActionTypeOrCreator: CHECKING_ACCOUNTS_LOAD,
    failureActionTypeOrCreator: CHECKING_ACCOUNTS_FAILURE,
    successActionTypeOrCreator: CHECKING_ACCOUNTS_SUCCESS,
    requestParams: {
      body: {
        query: CHECKING_ACCOUNTS_QUERY,
        variables: {
          affiliateOwnerName: affiliateOwnerName
        }
      },
      headers: {
        Authorization: "Bearer ".concat(authToken),
        'Client-Name': clientName
      },
      method: 'POST',
      url: "".concat(apiUrl)
    },
    type: _utils.FETCH
  };
};

exports.fetchCheckingAccounts = fetchCheckingAccounts;
//# sourceMappingURL=actions.js.map